export const APP_DOCS_TYPES = {
  ID_DOCUMENT: 'id_document',
  PASSPORT: 'passport',
  ADDRESS_VERIFICATION: 'address_verification',
  SOCIAL_SECURITY_CARD: 'social_security_card',
  CERTIFICATE_OF_INCORPORATION: 'certificate_of_incorporation',
  EIN_CONFIRMATION: 'employer_identification_number_confirmation',
  POWER_OF_ATTORNEY: 'power_of_attorney',
  CLIENT_REQUESTED: 'client_requested',
  SELFIE_VERIFICATION: 'selfie_verification'
};

export const APP_DOCS_NAME_BY_TYPE = {
  [APP_DOCS_TYPES.ID_DOCUMENT]: {
    heading: () => 'Nationality Verification',
    title: 'Driver’s License or State ID'
  },
  [APP_DOCS_TYPES.PASSPORT]: {
    heading: () => 'Nationality Verification',
    title: 'Passport'
  },
  [APP_DOCS_TYPES.ADDRESS_VERIFICATION]: {
    heading: () => 'Address Verification',
    title: 'Utility bill, bank statement, lease agreement, or current pay stub'
  },
  [APP_DOCS_TYPES.SOCIAL_SECURITY_CARD]: {
    heading: (suffix = '') => `SSN Verification for ${suffix}`,
    title: 'Social Security card, tax return, or W-2'
  },
  [APP_DOCS_TYPES.CERTIFICATE_OF_INCORPORATION]: {
    heading: () => 'Certification of Incorporation',
    title: 'Business’s certificate of incorporation or certificate of assumed name'
  },
  [APP_DOCS_TYPES.EIN_CONFIRMATION]: {
    heading: (suffix = '') => `Employer Identification Number for ${suffix}`,
    title: 'Verification of your EIN from the IRS, such as a 147c form'
  },
  [APP_DOCS_TYPES.POWER_OF_ATTORNEY]: {
    heading: () => '',
    title: ''
  },
  [APP_DOCS_TYPES.CLIENT_REQUESTED]: {
    heading: () => '',
    title: ''
  },
  [APP_DOCS_TYPES.SELFIE_VERIFICATION]: {
    heading: () => '',
    title: ''
  }
};
